$(document).ready(function(){
  const redirects = [
    'vitaminpulver-1',
    'mylky-messloffel-set-1',
    'mylky-kaffeetasse-1',
    'mylky-flaschen-burste-1',
    'your-tree-in-the-mylky-forest',    
    'mylky-flaschen-burste-2',
  ];

  const currentPath = window.location.pathname; // only the URL path

  for (const slug of redirects) {
    if (currentPath.includes(slug)) {
      window.location.replace('/products/mylky');
      break; // stop after first match
    }
  }
  
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has('add_to_cart') && urlParams.get('add_to_cart') === 'true') {
    setTimeout(() => {
      $('.product__info-wrapper .form button.main-button').click();
    }, 500); // Short delay for page load
  }

  $('.pdp-sticky-atc').on('click', function(){
    $('.product__info-wrapper .form button.main-button').click();
  })


  // Custom Menu Drawer CSS Start

  // Open your detail by default
  $('.menu-drawer-product-list-wrapper').attr('open', false);

  // Initialize states on page load
  $('.menu-drawer-product-list-wrapper summary').each(function () {
    let summary = $(this);
    let details = summary.parent('.menu-drawer-product-list-wrapper');
    let icon = summary.find('.menu-drawer-product-list-icon');

    summary.attr('aria-expanded', details.is('[open]'));
    icon.toggleClass('rotate-180', details.is('[open]'));
  });

  // Keep aria-expanded + rotate class in sync
  $('.menu-drawer-product-list-wrapper').on('toggle', function () {
    let details = $(this);
    let summary = details.children('.menu-drawer-product-list-wrapper summary');
    let icon = details.find('.menu-drawer-product-list-icon');

    summary.attr('aria-expanded', details.is('[open]'));
    icon.toggleClass('rotate-180', details.is('[open]'));
  });

  $('.close-localization').on('click touchstart', function(e) {

    e.preventDefault();  // prevent default link/button behavior
    e.stopPropagation(); // stop click from triggering elements behind it
    const disclosure = $(this).closest('.disclosure');
    const wrapper = disclosure.find('.disclosure__list-wrapper');

    // Remove hidden
    wrapper.removeAttr('hidden');

    // Close the details element properly
    disclosure.find('.disclosure__button').attr('aria-expanded', 'false');
    disclosure.find('.disclosure__list-wrapper').prop('hidden', true); // hide again
  });
  // Custom Menu Drawer CSS End

  var productSwiper = new Swiper('.product-usage-steps-wrapper', {
    loop: false,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function() {
        setActiveSteps(0); // default first step
      },
      slideChange: function() {
        setActiveSteps(this.activeIndex);
      },
    },
  });

  // Function to update steps progressively
  function setActiveSteps(index) {
    $('.product-usage-points-box').removeClass('active');
    $('.product-usage-points-box').each(function(i) {
      if (i <= index) {
        $(this).addClass('active');
      }
    });
  }

  // Clicking step should also sync with slider
  $('.product-usage-points-box').on('click', function() {
    var stepIndex = $(this).index();
    productSwiper.slideTo(stepIndex);
    setActiveSteps(stepIndex);
  });

  (function () {
    const DESKTOP_BREAKPOINT = 767;

    // Remove upsell
    $(document).on('click.upsell', '.product_bundle_container .remove_upsell', function (e) {
      e.preventDefault();
      e.stopPropagation();

      const container = $(this).closest('.product_bundle_container');
      $(this).removeClass('upsell-selected');

      container.find('.upsell-appended').addClass('remove_upsell_product');
      container.find('.upsell_checkbox').removeClass('upsell_checked');
      container.find('.mobile_upsell_checkbox.upsell_checkbox').removeClass('upsell_checked');
      container.find('.upsell-atc').addClass('upsell-atc-hidden');
    });

    // Toggle upsell (desktop only)
    $(document).on('click.upsell', '.product_bundle_upsell_wrapper', function () {
      const container = $(this).closest('.product_bundle_container');
      if (window.innerWidth >= DESKTOP_BREAKPOINT) {  
        $(this).toggleClass('upsell-selected');
        container.find('.upsell_checkbox').toggleClass('upsell_checked');
        container.find('.upsell-appended').toggleClass('remove_upsell_product');
        container.find('.upsell-atc').toggleClass('upsell-atc-hidden');
      }
      else {
        $(this).toggleClass('upsell-selected');
        container.find('.upsell_checkbox').toggleClass('upsell_checked');
        container.find('.upsell-appended').toggleClass('remove_upsell_product');
        container.find('.upsell-atc').toggleClass('upsell-atc-hidden');
      }
    });

    // $(document).on('click', '.upsell-atc button[type="button"]', function (e) {
    //   e.preventDefault();
    //   e.stopImmediatePropagation();

    //   const button = $(this);
    //   const container = button.closest('.product_bundle_container');

    //   // 🔹 Main product form
    //   const mainForm = $('.product__info-wrapper form[data-type="add-to-cart-form"]');
    //   if (!mainForm.length) {
    //     console.error('Main product form not found');
    //     return;
    //   }

    //   const mainVariantId = mainForm.find('input[name="id"]').val();
    //   const mainQty = parseInt(mainForm.find('input[name="quantity"]').val(), 10) || 1;

    //   if (!mainVariantId) {
    //     console.error('Main variant missing');
    //     return;
    //   }

    //   // 🔹 Check upsell state
    //   const isUpsellChecked = container.find('.upsell_checkbox').hasClass('upsell_checked');

    //   // 🔹 Base payload (always add main product)
    //   const payload = {
    //     items: [
    //       {
    //         id: mainVariantId,
    //         quantity: mainQty
    //       }
    //     ]
    //   };

    //   // 🔹 If upsell selected → add upsell item
    //   if (isUpsellChecked) {
    //     // const upsellVariantId = container
    //     //   .find('form input[name="id"]')
    //     //   .val();
    //     const upsellVariantId = container.data('upsell-variant-id');

    //     if (upsellVariantId) {
    //       payload.items.push({
    //         id: upsellVariantId,
    //         quantity: 1,
    //         properties: { _Gf_pdp: 'mylky_gift' }
    //       });
    //     }
    //   }

    //   // 🔹 UI loading state
    //   button.addClass('loading').attr('aria-disabled', 'true');

    //   $.ajax({
    //     url: '/cart/add.js',
    //     type: 'POST',
    //     dataType: 'json',
    //     contentType: 'application/json',
    //     data: JSON.stringify(payload),
    //     success: function (response) {
    //       const cart =
    //         document.querySelector('cart-notification') ||
    //         document.querySelector('cart-drawer');

    //       if (cart && typeof cart.renderContents === 'function') {
    //         cart.renderContents(response);
    //       }

    //       document.dispatchEvent(
    //         new CustomEvent('cart:refresh', { detail: response })
    //       );
    //     },
    //     error: function (xhr) {
    //       console.error('Add to cart failed', xhr.responseJSON || xhr.responseText);
    //     },
    //     complete: function () {
    //       button.removeClass('loading').removeAttr('aria-disabled');
    //     }
    //   });
    // });

  })();

  // Discounted Badge Text
  // function addDiscountBadgeToCartItem() {
  //   const targetVariantId = '44449800618054';

  //   $('.qsc2-product-item__product-title').each(function () {
  //     const title = $(this);
  //     const link = title.find('a');

  //     if (!link.length) return;

  //     const href = link.attr('href');

  //     let discountText = 'Save €5'; // fallback

  //     if (window.location.hostname.includes('.com.au')) {
  //       discountText = 'Save $5';
  //     } else if (window.location.hostname.includes('.ch')) {
  //       discountText = 'Save CHF 5';
  //     }

  //     if (href && href.includes(`variant=${targetVariantId}`)) {
  //       if (!title.find('.discount-drawer-badge').length) {
  //         title.append(
  //           `<span class="discount-drawer-badge"> - (${discountText})</span>`
  //         );
  //       }
  //     }
  //   });
  // }

  // (function observeCartChanges() {
  //   const observer = new MutationObserver(() => {
  //     // Run only if cart items exist
  //     if (document.querySelector('.qsc2-product-item__product-title')) {
  //       addDiscountBadgeToCartItem();
  //     }
  //   });

  //   observer.observe(document.body, {
  //     childList: true,
  //     subtree: true
  //   });
  // })();
});

// green friday------------------------------------------------------------------------------------------
// const activeProductId = "44038160810054"; //44038160810054   44038165692486

// const allOptions = document.querySelectorAll(
//   ".gf-product-image, .gf-extra-product-container"
// );

// const allHeadings = document.querySelectorAll(".gf-pdp-heading-value");

// // 🔹 Function to show only matching heading
// function showMatchingHeading(productId) {
//   allHeadings.forEach((p) => {
//     if (p.getAttribute("data-producttitle") === productId) {
//       p.style.display = "block";
//     } else {
//       p.style.display = "none";
//     }
//   });
// }

// // 🔹 Initialize active image + heading
// allOptions.forEach((el) => {
//   if (el.getAttribute("data-productid") === activeProductId) {
//     el.classList.add("gf-pdp-active");
//     showMatchingHeading(activeProductId);
//   } else {
//     el.classList.remove("gf-pdp-active");
//   }
// });

// // 🔹 Click to toggle active state and show related heading
// allOptions.forEach((el) => {
//   el.addEventListener("click", () => {
//     allOptions.forEach((i) => i.classList.remove("gf-pdp-active"));
//     el.classList.add("gf-pdp-active");

//     const productId = el.getAttribute("data-productid");
//     showMatchingHeading(productId);
//   });
// });

// // const gc_originalFetch = window.fetch;
// const gc_originalSend = XMLHttpRequest.prototype.send;
// let gc_cartData;
// let old_quantity;
// let new_quantity;
// // let mylkyMainPro = "42571798839366" //dummy product
// let mylkyMainPro = "42571798609990"

// async function gcGetCartData() {
//   const res = await fetch("/cart.json", {
//     headers: { "x-bypass-intercept": "1" }
//   });
//   gc_cartData = await res.json();
//   return gc_cartData;
// }

// async function getExistingProductQty(variantId) {
//   const res = await fetch('/cart.js');
//   const cart = await res.json();
//   const item = cart.items.find(i => (String(i?.variant_id)) === String(variantId));
//   return item ? item.quantity : 0;
// }

// document.addEventListener('DOMContentLoaded', async () => {
//   const variantId = mylkyMainPro; // Replace with real variant ID
//   const qty = await getExistingProductQty(variantId);
//   old_quantity = qty;
// });

// async function sectionRender() {
//   //  try {
//   //       document.dispatchEvent(new CustomEvent("cart:change"));
//   //     } catch (error) {
//   //       console.log(error,"---error");
//   //     }

//   const cartDrawer = document.querySelector('cart-drawer');
//   if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
//     const sections = cartDrawer.getSectionsToRender().map(s => s.section);
//     const res = await fetch(`/cart?sections=${sections.join(',')}`);
//     const parsed = await res.json();
//     cartDrawer.renderContents({ sections: parsed });
//   }
// }

// async function greenFriday() {
//   await gcGetCartData();
//   let mainProduct = gc_cartData?.items?.find((cartItem) => {
//     return String(cartItem?.variant_id) === mylkyMainPro;
//   });
//   new_quantity = mainProduct?.quantity

//   if (mainProduct) {
//     await greenFridayAddToCart(mainProduct?.quantity);
//   } else {
//     await greenFridayUpdateToCart();
//   }
// }

// function getLocalStorage() {
//   let cart = localStorage.getItem('gf_cart');
//   return cart ? JSON.parse(cart) : [];
// }

// // Save cart to localStorage
// function saveLocalStorage(cart, quantity = 1) {
//   // localStorage.setItem('gf_cart', JSON.stringify(cart));
//   for (let i = 0; i < quantity; i++) {
//     localStorage.setItem('gf_cart', JSON.stringify(cart));
//   }
// }

// function getVariantCount(variantId) {
//   const cart = getLocalStorage();
//   let count = 0;

//   for (const item of cart) {
//     if (parseInt(item) === parseInt(variantId)) {
//       // If you store quantity, add that instead of 1
//       count += item.quantity || 1;
//     }
//   }

//   return count;
// }


// // Remove entire cart
// function removeLocalStorage() {
//   localStorage.removeItem('gf_cart');
// }

// // Add a variant ID to cart
// // function addToLocalStorage(variantId) {
// //   let cart = getLocalStorage();
// //   let proVariantId = parseInt(variantId)
// //   cart.push(proVariantId);
// //   saveLocalStorage(cart);
// // }

// function addToCart(productId, quantity = 1) {
//   let cart = getLocalStorage();

//   // Add productId multiple times based on quantity
//   for (let i = 0; i < quantity; i++) {
//     cart.push(parseInt(productId));
//   }

//   saveLocalStorage(cart);
// }

// function removeFromLocalStorage(variantId, quantity = 1) {
//   let cart = getLocalStorage();
//   const idToRemove = parseInt(variantId);

//   for (let i = 0; i < quantity; i++) {
//     const index = cart.lastIndexOf(idToRemove);
//     if (index !== -1) {
//       cart.splice(index, 1);
//     } else {
//       break;
//     }
//   }
//   saveLocalStorage(cart);
// }

// function getLastVariant() {
//   let cart = localStorage.getItem('gf_cart');
//   if (!cart) return null;
//   cart = JSON.parse(cart);
//   if (cart.length === 0) return null;
//   return cart[cart.length - 1];
// }

// async function greenFridayUpdateToCart(quantity) {
//   const activeProduct = document.querySelector('.green-friday-product-wrapper .gf-pdp-active');
//   const productId = activeProduct.getAttribute('data-productid');
//   const giftVariantId = "44038167756870";
//   const selectedProductId = parseInt(productId);
//   let diff_quantity = Math.abs(new_quantity - old_quantity);

//   let mylkyMainProData = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem?.variant_id) === mylkyMainPro
//     );
//   })

//   let mylkyProQuantity = mylkyMainProData?.quantity;
//   // Filter the cart for both — returns an array of matches
//   let giftProduct
//    = gc_cartData?.items?.filter((cartItem) => {
//     return (
//       cartItem.properties._Gf_pdp === "giftItem" || cartItem.properties._Gf_Tree_pdp === "giftItem"
//     );
//   });

//   let treeGiftPro = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem.variant_id) === "44038167756870" && cartItem.properties._Gf_pdp === "giftItem"
//     );
//   });

//   let freeGiftPro = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem.variant_id) === productId &&
//       cartItem.properties._Gf_pdp === "giftItem"
//     );
//   });

//   if (!quantity) {
//     const updates = {};

//     giftProduct.forEach((cartItem) => {
//       updates[cartItem.key] = 0;
//     });

//     const response = await fetch("/cart/update.js?_gf_pdp", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({ updates }),
//     });

//     const result = await response.json();

//     if (!response.ok) {
//       console.error("🚫 Error:", result);
//       throw new Error(`Add to cart failed: ${response.status}`);
//     }

//     removeLocalStorage();
//     await sectionRender();
//   } else {
//     if (old_quantity < new_quantity) {
//       let updates = {}
//       let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => cartItem.properties._Gf_pdp);
//       let totalMylkyGiftQuantity = mylkyGiftPro.reduce(
//         (total, item) => total + (item.quantity || 0),
//         0
//       );

//       let mylkyTreePro = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//       let totalMylkyTreeQuantity = mylkyTreePro?.quantity

//       let freeTreeQuantity = mylkyProQuantity - totalMylkyTreeQuantity
//       let freeGiftQuantity = mylkyProQuantity - totalMylkyGiftQuantity

//       console.log(freeGiftQuantity, "freeGiftQuantity", freeGiftPro?.quantity, treeGiftPro?.quantity, "freeTreeQuantity", treeGiftPro?.quantity);
//       console.log(freeGiftPro, "freeGiftPro")
//       if (freeGiftPro) {
//         // [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + freeGiftQuantity,
//         if(String(freeGiftPro?.variant_id) ===  "44038167756870"){
//           updates = {
//               [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + (diff_quantity*2),
//             };
//         }else{
//           if (treeGiftPro) {
//           updates = {
//             [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) + diff_quantity,
//             [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + diff_quantity,
//           };
//         } else {
//           updates = {
//             [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + diff_quantity,
//           };
//         }
//         }
//       }

//       console.log(updates, "updates from one");
//       const response = await fetch("/cart/update.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ updates }),
//       });

//       const result = await response.json();
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
//       addToCart(productId, diff_quantity);
//       old_quantity = quantity;
//       await sectionRender();
//     } else {
//       let lastVariant = getLastVariant();
//       let lastProVariant = gc_cartData?.items?.find((cartItem) => {
//         return (
//           String(cartItem.variant_id) === String(lastVariant) &&
//           cartItem.properties._Gf_pdp === "giftItem"
//         );
//       });

//       let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => cartItem.properties._Gf_pdp);
//       let totalMylkyGiftQuantity = mylkyGiftPro.reduce(
//         (total, item) => total + (item.quantity || 0),
//         0
//       );
//       let updates = {};
//       let mylkyTreePro = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//       let totalMylkyTreeQuantity = mylkyTreePro?.quantity;
//       let freeTreeQuantity = Math.abs(mylkyProQuantity - totalMylkyTreeQuantity)

//       if (totalMylkyGiftQuantity > mylkyProQuantity) {
//         // if (treeGiftPro) {
//         //   console.log("-------1");
//         //   updates = {
//         //     [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//         //   };
//         // }
//         if (lastProVariant) {
//             if(String(lastProVariant?.variant_id) ===  "44038167756870"){
//             updates = {
//                 [lastProVariant?.key]: (lastProVariant?.quantity || 0) - (diff_quantity * 2),
//               };
//                removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//             } else if (treeGiftPro) {
//             updates = {
//               [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//               [lastProVariant?.key]: (lastProVariant?.quantity || 0) - diff_quantity,
//             };
//             removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//           } else {
//             updates = {
//               [lastProVariant?.key]: (lastProVariant?.quantity || 0) - diff_quantity,
//             };
//             removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//           }
//         } else {
//           if (treeGiftPro) {
//             updates = {
//               [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//             };
//           }
//         }
//       } else  {
//         if (treeGiftPro) {
//           updates = {
//             [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//           };
//         }
//       }
//       console.log(updates, "updates from two");

//       const response = await fetch("/cart/update.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ updates }),
//       });

//       const result = await response.json();
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
//       old_quantity = quantity;
//       await sectionRender();
//     }
//   }
// }

// async function greenFridayAddToCart(quantity) {
//   try {
//     const activeProduct = document.querySelector('.green-friday-product-wrapper .gf-pdp-active');
//     const productId = activeProduct.getAttribute('data-productid');
//     const giftVariantId = "44038167756870";
//     const selectedProductId = parseInt(productId);
//     let diff_quantity = Math.abs(new_quantity - old_quantity);
//     // let giftProduct = gc_cartData?.items?.filter((cartItem) => {
//     //   return (
//     //     String(cartItem?.variant_id) === giftVariantId
//     //     || parseInt(cartItem?.variant_id) === selectedProductId
//     //   );
//     // })  || [];

//       let giftProduct = gc_cartData?.items?.filter((cartItem) => {
//       return (
//        cartItem.properties._Gf_pdp
//       );
//     }) || [];

//     let selectedProduct = gc_cartData?.items?.filter((cartItem) => {
//       return (
//         parseInt(cartItem?.variant_id) === selectedProductId && cartItem.properties._Gf_pdp === "giftItem"
//       );
//     }) || [];

//     if (giftProduct.length <= 0) {
//       const itemsToAdd = [
//         // {
//         //   id: parseInt(productId),
//         //   quantity: 1,
//         //   properties: {
//         //     _Gf_pdp: "giftItem"
//         //   }
//         // },
//         {
//           id: 44038167756870,
//           quantity: 1,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const response = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: itemsToAdd }),
//       });

//       const result = await response.json();
//       console.log(productId, "productId")
//       addToCart(productId);
//       old_quantity = quantity
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }

//        const treeItem = [
//         {
//             id: parseInt(productId),
//           quantity: 1,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const treeResponse = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: treeItem }),
//       });

//       const treeResult = await treeResponse.json();
//       await sectionRender()
//     } else if (selectedProduct?.length <= 0 && old_quantity < new_quantity) {

//       let diff_quantity = new_quantity - old_quantity
//       const itemsToAdd = [
//         // {
//         //   id: parseInt(productId),
//         //   quantity: diff_quantity,
//         //   properties: {
//         //     _Gf_pdp: "giftItem"
//         //   }
//         // }
//         {
//           id: 44038167756870,
//           quantity: diff_quantity,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const response = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: itemsToAdd }),
//       });

//       const result = await response.json();
//       console.log(productId, "productId2")
//       console.log(diff_quantity, "diff_quantity")
//       addToCart(productId, diff_quantity);

//       old_quantity = quantity
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
      
//       const treeItem = [
//          {
//           id: parseInt(productId),
//           quantity: diff_quantity,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const treeResponse = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: treeItem }),
//       });

//       const treeResult = await treeResponse.json();
      
//       await sectionRender()
//     } else {
//       await greenFridayUpdateToCart(quantity)
//     }
//   } catch (error) {
//     console.error("❌ Error adding to cart:", error);
//   }
// }

// const gcCartApi = [
//   { label: "add", url: "/cart/add.js" },
//   { label: "add", url: "/cart/add" },
//   { label: "change", url: "/cart/change.js" },
//   { label: "change", url: "/cart/change" },
//   { label: "update", url: "/cart/update.js" },
//   { label: "update", url: "/cart/update" },
//   { label: "clear", url: "/cart/clear.js" },
//   { label: "clear", url: "/cart/clear" },
// ];

// document.addEventListener('cart:changed', async () => {
//   await gcGetCartData();
//   await greenFriday();
// });

// window.fetch = async function (input, init = {}) {
//   const url = typeof input === 'string'
//     ? input
//     : (input && typeof input.url === 'string' ? input.url : undefined);

//   if (typeof url !== 'string') {
//     const response = await gc_originalFetch(input, init);
//     return response;
//   }

//   if (url.includes('_gf_pdp')) {
//     return await gc_originalFetch(input, init);
//   }

//   const isCartMutation = gcCartApi.some(route => {
//     const base = route.url.replace(".js", "");
//     return (
//       (url.includes(base) || url.includes(base + ".js"))
//     );
//   });

//   const body = init.body || null;
//   let line, quantity;
//   let parsedBody;

//   try {
//     parsedBody = (typeof body === "string" && body.startsWith("{"))
//       ? JSON.parse(body)
//       : body;
//   } catch {
//     parsedBody = body;
//   }

//   if (parsedBody instanceof URLSearchParams || typeof parsedBody === "string") {
//     const params = new URLSearchParams(
//       typeof parsedBody === "string" ? parsedBody : parsedBody.toString()
//     );
//     line = parseInt(params.get("line"), 10);
//     quantity = parseInt(params.get("quantity"), 10);
//   } else if (typeof parsedBody === "object" && parsedBody !== null) {
//     line = parseInt(parsedBody.line, 10);
//     quantity = parseInt(parsedBody.quantity, 10);
//   }

//   const response = await gc_originalFetch(input, init);
//   if (isCartMutation && response.ok) {
//     setTimeout(async () => {
//       document.dispatchEvent(new CustomEvent('cart:changed'));
//     }, 200);
//   }
//   return response;
// };

// const originalXhrSend = XMLHttpRequest.prototype.send;
// XMLHttpRequest.prototype.send = async function (body) {
//   const xhr = this;
//   const url = xhr._url || xhr?.__sentry_xhr?.url || "";
//   const method = xhr._method || xhr?.__sentry_xhr?.method || "GET";
//   let parsedBody;
//   try {
//     parsedBody = typeof body === "string" && body.startsWith("{")
//       ? JSON.parse(body)
//       : body;
//   } catch {
//     parsedBody = body;
//   }

//   if (url.includes('_gf_pdp')) {
//     return await gcXmlApiRequest(xhr, body);
//   }

//   let rawBody = "";
//   if (typeof parsedBody === "string") {
//     rawBody = parsedBody;
//   } else if (parsedBody instanceof URLSearchParams) {
//     rawBody = parsedBody.toString();
//   } else if (parsedBody instanceof FormData) {
//     rawBody = new URLSearchParams(parsedBody).toString();
//   }
//   const urlLineParams = new URLSearchParams(rawBody);
//   const line = parseInt(urlLineParams.get("line"), 10);
//   const quantity = parseInt(urlLineParams.get("quantity"), 10);
//   const cartEndpoints = [
//     '/cart/add.js', '/cart/change.js', '/cart/update.js',
//     '/cart/add', '/cart/change', '/cart/update'
//   ];
//   const isCartMutation = gcCartApi.some(route => {
//     const base = route.url.replace(".js", "");
//     return (
//       (url.includes(base) || url.includes(base + ".js"))
//     );
//   });

//   let updatApi = [
//     { label: "change", url: "/cart/change.js" },
//     { label: "change", url: "/cart/change" },
//     { label: "update", url: "/cart/update.js" },
//     { label: "update", url: "/cart/update" },
//   ];
//   const isUpdateCartMutation = updatApi.some(route => {
//     const base = route.url.replace(".js", "");
//     return (
//       (url.includes(base) || url.includes(base + ".js"))
//     );
//   });

//   if (isUpdateCartMutation) {
//     let cartDataItem = await gcGetCartData();
//     cartDataItem?.items?.forEach((item, index) => {
//     });

//     let isGiftItem = cartDataItem?.items?.find((cartItem) => String(cartItem?.key) === String(parsedBody?.id));
//     if ((line && cartDataItem?.items[line - 1]) || isGiftItem) {
//       let cartItem = cartDataItem.items[line - 1] || isGiftItem;

//       const params = new URLSearchParams(body);
//       let payLoadData
//       try {
//         payLoadData = JSON.parse(body);
//       } catch (e) {
//         console.error("Failed to parse JSON body:", e);
//       }
//       parsedBody = {};

//       let mylkyMainProData = gc_cartData?.items?.find((cartItem) => String(cartItem?.variant_id) === mylkyMainPro);
//       let mylkyProQuantity = mylkyMainProData?.quantity;

//       if (String(mylkyMainProData?.variant_id) === String(cartItem?.variant_id)) {
//         old_quantity = cartItem?.quantity
//       }

//       if (cartItem.properties && (cartItem.properties._Gf_pdp || cartItem.properties._Gf_Tree_pdp)) {
//         let mylkyMainProData = gc_cartData?.items?.find((cartItem) => String(cartItem?.variant_id) === mylkyMainPro);
//         let mylkyProQuantity = mylkyMainProData?.quantity;
//         let mylkyPlantProData = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//         let mylkyPlantQuantity = mylkyPlantProData?.quantity
//         let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => (cartItem.properties._Gf_pdp ));
//         let mylkyGiftQuantity = mylkyGiftPro.reduce(
//           (total, item) => total + (item.quantity || 0),
//           0
//         );

//         let mylkyGiftTreePro = gc_cartData?.items?.filter((cartItem) => (cartItem.properties._Gf_pdp && String(cartItem?.variant_id) !== "44038167756870") );
//         let mylkyGiftTreeQuantity = mylkyGiftTreePro.reduce(
//           (total, item) => total + (item.quantity || 0),
//           0
//         );

//         let totalTreeCount = getVariantCount(44038167756870);
//         let totalMylkyGiftQuantity = mylkyGiftTreeQuantity + totalTreeCount;
       
//         if (mylkyGiftPro?.some(gift => gift.variant_id === cartItem?.variant_id)) {
//               let totalMylkyTreeQuantity = totalMylkyGiftQuantity;
//               if(String(cartItem?.variant_id) === "44038167756870"){
//                 if(parseInt(payLoadData.quantity) === 0){
//                     let treeDiff = cartItem?.quantity
//                     removeFromLocalStorage(cartItem?.variant_id, treeDiff)
//                     return await gcXmlApiRequest(xhr, body);
//                 } else {
//                       try {
//                         if (typeof body === "string") {
//                           if (body.includes("quantity=")) {
//                             const params = new URLSearchParams(body);
//                             if (params.has("quantity")) {
//                               params.set("quantity", cartItem?.quantity); 
//                               body = params.toString();
//                             }
//                           }
//                           else if (body.trim().startsWith("{")) {
//                             const temp = JSON.parse(body);
//                             if (temp && temp.quantity !== undefined) {
//                               temp.quantity = cartItem?.quantity; 
//                               body = JSON.stringify(temp);
//                             }
//                           }
//                         }
//                       } catch (err) {
//                         console.error("Failed to adjust quantity:", err);
//                       }
//                       return await gcXmlApiRequest(xhr, body);
//                 }
//               }else{
//                   if (totalMylkyGiftQuantity < mylkyProQuantity) {
//                     let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
//                     console.log(cartItem?.quantity, "cartItem?.quantity", payLoadData.quantity, "payLoadData.quantity")
//                     if (cartItem?.quantity < payLoadData.quantity) {
//                       addToCart(cartItem?.variant_id)
//                     } else {
//                       removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
//                     }
//                     return await gcXmlApiRequest(xhr, body);
//                   } else {
//                     if (cartItem?.quantity < payLoadData.quantity) {
//                       try {
//                         if (typeof body === "string") {
//                           if (body.includes("quantity=")) {
//                             const params = new URLSearchParams(body);
//                             if (params.has("quantity")) {
//                               params.set("quantity", cartItem?.quantity); 
//                               body = params.toString();
//                             }
//                           }
//                           else if (body.trim().startsWith("{")) {
//                             const temp = JSON.parse(body);
//                             if (temp && temp.quantity !== undefined) {
//                               temp.quantity = cartItem?.quantity; 
//                               body = JSON.stringify(temp);
//                             }
//                           }
//                         }
//                       } catch (err) {
//                         console.error("Failed to adjust quantity:", err);
//                       }
//                       return await gcXmlApiRequest(xhr, body);
//                     } else {
//                       let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
//                       removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
//                       return await gcXmlApiRequest(xhr, body);
//                     }
//                   }
//               }
//             }
//           }
//           // if (cartItem?.quantity < payLoadData.quantity) {
//           //   if (typeof parsedBody === "object") {
//           //     parsedBody.quantity = cartItem?.quantity;
//           //   } else if (parsedBody instanceof URLSearchParams) {
//           //     parsedBody.set("quantity", cartItem?.quantity);
//           //   }
//           //   const newParams = new URLSearchParams(parsedBody).toString();
//           //   return await gcXmlApiRequest(xhr, newParams);
//           // } else {
//           //   let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
//           //   removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
//           //   return await gcXmlApiRequest(xhr, body);
//           // }
//         }
//   }
//   await gcXmlApiRequest(xhr, body);
//   if (isCartMutation) {
//     setTimeout(() => {
//       document.dispatchEvent(new CustomEvent('cart:changed'));
//     }, 700);
//   }
// };

// async function gcXmlApiRequest(xhr, params) {
//   const intervals = 10;
//   const maxTries = 50;
//   let tries = 0;
//   while (xhr.readyState !== XMLHttpRequest.OPENED && tries < maxTries) {
//     await new Promise(res => setTimeout(res, intervals));
//     tries++;
//   }
//   if (xhr.readyState === XMLHttpRequest.OPENED) {
//     try {
//       gc_originalSend.call(xhr, params);
//     } catch (err) {
//       console.error("Failed during send:-", err);
//     }
//   } else {
//     console.warn("xhr not open after waiting, skipping send");
//   }
// }

// const firstProduct = document.querySelector(
//   '.green-friday-product-wrapper .gf-product-image'
// );

// const activeProductId = firstProduct?.dataset.productid; // 44038165692486

// const allOptions = document.querySelectorAll(
//   ".gf-product-image, .gf-extra-product-container"
// );
// const allHeadings = document.querySelectorAll(".gf-pdp-heading-value");

const allOptions = document.querySelectorAll(
  ".gf-product-image, .gf-extra-product-container"
);
const allHeadings = document.querySelectorAll(".gf-pdp-heading-value");

const isGiftAvailable = (el) =>
  !!el.dataset.productid && el.dataset.available !== "false";

// First gift that is in stock (DOM order = product_1..product_7 order)
const activeProductId = Array.from(allOptions).find(isGiftAvailable)?.dataset.productid;

// 🔹 Function to show only matching heading
function showMatchingHeading(productId) {
  allHeadings.forEach((p) => {
    if (p.getAttribute("data-producttitle") === productId) {
      p.style.display = "block";
    } else {
      p.style.display = "none";
    }
  });
}

// // 🔹 Initialize active image + heading
// allOptions.forEach((el) => {
//   if (el.getAttribute("data-productid") === activeProductId) {
//     el.classList.add("gf-pdp-active");
//     showMatchingHeading(activeProductId);
//   } else {
//     el.classList.remove("gf-pdp-active");
//   }
// });

// // 🔹 Click to toggle active state and show related heading
// allOptions.forEach((el) => {
//   el.addEventListener("click", () => {
//     allOptions.forEach((i) => i.classList.remove("gf-pdp-active"));
//     el.classList.add("gf-pdp-active");

//     const productId = el.getAttribute("data-productid");
//     showMatchingHeading(productId);
//   });
// });

// 🔹 Initialize active image + heading
allOptions.forEach((el) => {
  if (activeProductId && el.getAttribute("data-productid") === activeProductId) {
    el.classList.add("gf-pdp-active");
    showMatchingHeading(activeProductId);
  } else {
    el.classList.remove("gf-pdp-active");
  }
});
if (!activeProductId) allHeadings.forEach((p) => (p.style.display = "none")); // nothing in stock

// 🔹 Click to toggle active state and show related heading
allOptions.forEach((el) => {
  el.addEventListener("click", () => {
    if (!isGiftAvailable(el)) return; // ignore sold-out tiles
    allOptions.forEach((i) => i.classList.remove("gf-pdp-active"));
    el.classList.add("gf-pdp-active");

    const productId = el.getAttribute("data-productid");
    showMatchingHeading(productId);
  });
});

const gc_originalFetch = window.fetch;
const gc_originalSend = XMLHttpRequest.prototype.send;
let gc_cartData;
let old_quantity;
let new_quantity;
// let mylkyMainPro = "42571798839366"
let mylkyMainPro = "42571798609990"

async function gcGetCartData() {
  const res = await fetch("/cart.json", {
    headers: { "x-bypass-intercept": "1" }
  });
  gc_cartData = await res.json();
  return gc_cartData;
}

async function getExistingProductQty(variantId) {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  // const item = cart.items.find(i => (String) === String(variantId));
  const item = cart.items.find(i => String(i?.variant_id) === String(variantId));
  return item ? item.quantity : 0;
}

document.addEventListener('DOMContentLoaded', async () => {
  const variantId = mylkyMainPro; // Replace with real variant ID
  const qty = await getExistingProductQty(variantId);
  old_quantity = qty;
});

// async function sectionRender() {
//   //  try {
//   //       document.dispatchEvent(new CustomEvent("cart:change"));
//   //     } catch (error) {
//   //       console.log(error,"---error");
//   //     }

//   const cartDrawer = document.querySelector('cart-drawer');
//   if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
//     const sections = cartDrawer.getSectionsToRender().map(s => s.section);
//     const res = await fetch(`/cart?sections=${sections.join(',')}`);
//     const parsed = await res.json();
//     cartDrawer.renderContents({ sections: parsed });
//   }
// }

async function sectionRender() {
  const cartDrawer = document.querySelector('cart-drawer');
  if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;

  const sections = cartDrawer.getSectionsToRender().map(s => s.section || s.id);
  const t = Date.now();
  const [res, cart] = await Promise.all([
    fetch(`/cart?sections=${sections.join(',')}&t=${t}`, { cache: 'no-store' }),
    fetch(`/cart.js?t=${t}`, { cache: 'no-store' }).then(r => r.json()),
  ]);
  if (!res.ok) {
    console.error('sectionRender failed', res.status);
    return;
  }
  const parsed = await res.json();

  cartDrawer.renderContents({ sections: parsed });
  cartDrawer.classList.toggle('is-empty', cart.item_count === 0);
}

// async function greenFriday() {
//   await gcGetCartData();
//   let mainProduct = gc_cartData?.items?.find((cartItem) => {
//     return String(cartItem?.variant_id) === mylkyMainPro;
//   });
//   new_quantity = mainProduct?.quantity

//   if (mainProduct) {
//     await greenFridayAddToCart(mainProduct?.quantity);
//   } else {
//     await greenFridayUpdateToCart();
//   }
// }

let gfRunning = false;
let gfRerun = false;

async function greenFriday() {
  if (gfRunning) { gfRerun = true; return; }   // already running: remember to go once more
  gfRunning = true;
  try {
    do {
      gfRerun = false;
      await gcGetCartData();                    // always read fresh inside the lock
      const mainProduct = gc_cartData?.items?.find(
        (cartItem) => String(cartItem?.variant_id) === mylkyMainPro
      );
      new_quantity = mainProduct?.quantity;

      if (mainProduct) {
        await greenFridayAddToCart(mainProduct.quantity);
      } else {
        await greenFridayUpdateToCart();
      }
    } while (gfRerun);                          // events that arrived mid-run get one fresh pass
  } finally {
    gfRunning = false;                          // never stays locked, even if a request throws
  }
}

function getLocalStorage() {
  let cart = localStorage.getItem('gf_cart');
  return cart ? JSON.parse(cart) : [];
}

// Save cart to localStorage
function saveLocalStorage(cart, quantity = 1) {
  // localStorage.setItem('gf_cart', JSON.stringify(cart));
  for (let i = 0; i < quantity; i++) {
    localStorage.setItem('gf_cart', JSON.stringify(cart));
  }
}

function getVariantCount(variantId) {
  const cart = getLocalStorage();
  let count = 0;

  for (const item of cart) {
    if (parseInt(item) === parseInt(variantId)) {
      // If you store quantity, add that instead of 1
      count += item.quantity || 1;
    }
  }

  return count;
}

// Remove entire cart
function removeLocalStorage() {
  localStorage.removeItem('gf_cart');
}

// Add a variant ID to cart
// function addToLocalStorage(variantId) {
//   let cart = getLocalStorage();
//   let proVariantId = parseInt(variantId)
//   cart.push(proVariantId);
//   saveLocalStorage(cart);
// }

function addToCart(productId, quantity = 1) {
  let cart = getLocalStorage();

  // Add productId multiple times based on quantity
  for (let i = 0; i < quantity; i++) {
    cart.push(parseInt(productId));
  }

  saveLocalStorage(cart);
}

function removeFromLocalStorage(variantId, quantity = 1) {
  let cart = getLocalStorage();
  const idToRemove = parseInt(variantId);

  for (let i = 0; i < quantity; i++) {
    const index = cart.lastIndexOf(idToRemove);
    if (index !== -1) {
      cart.splice(index, 1);
    } else {
      break;
    }
  }
  saveLocalStorage(cart);
}

function getLastVariant() {
  let cart = localStorage.getItem('gf_cart');
  if (!cart) return null;
  cart = JSON.parse(cart);
  if (cart.length === 0) return null;
  return cart[cart.length - 1];
}

// async function greenFridayUpdateToCart(quantity) {
//   const activeProduct = document.querySelector('.green-friday-product-wrapper .gf-pdp-active');
//   const productId = activeProduct?.getAttribute('data-productid');
//   const giftVariantId = "44038167756870";
//   const selectedProductId = parseInt(productId);
//   let diff_quantity = Math.abs(new_quantity - old_quantity);

//   let mylkyMainProData = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem?.variant_id) === mylkyMainPro
//     );
//   })

//   let mylkyProQuantity = mylkyMainProData?.quantity;
//   // Filter the cart for both — returns an array of matches
//   let giftProduct
//    = gc_cartData?.items?.filter((cartItem) => {
//     return (
//       cartItem.properties._Gf_pdp === "giftItem" || cartItem.properties._Gf_Tree_pdp === "giftItem"
//     );
//   });

//   let treeGiftPro = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem.variant_id) === "44038167756870" && cartItem.properties._Gf_pdp === "giftItem"
//     );
//   });

//   let freeGiftPro = gc_cartData?.items?.find((cartItem) => {
//     return (
//       String(cartItem.variant_id) === productId &&
//       cartItem.properties._Gf_pdp === "giftItem"
//     );
//   });

//   if (!quantity) {
//     const updates = {};

//     giftProduct.forEach((cartItem) => {
//       updates[cartItem.key] = 0;
//     });

//     const response = await fetch("/cart/update.js?_gf_pdp", {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//         Accept: "application/json",
//       },
//       body: JSON.stringify({ updates }),
//     });

//     const result = await response.json();

//     if (!response.ok) {
//       console.error("🚫 Error:", result);
//       throw new Error(`Add to cart failed: ${response.status}`);
//     }

//     removeLocalStorage();
//     await sectionRender();
//   } else {
//     if (old_quantity < new_quantity) {
//       let updates = {}
//       let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => cartItem.properties._Gf_pdp);
//       let totalMylkyGiftQuantity = mylkyGiftPro.reduce(
//         (total, item) => total + (item.quantity || 0),
//         0
//       );

//       let mylkyTreePro = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//       let totalMylkyTreeQuantity = mylkyTreePro?.quantity

//       let freeTreeQuantity = mylkyProQuantity - totalMylkyTreeQuantity
//       let freeGiftQuantity = mylkyProQuantity - totalMylkyGiftQuantity

//       console.log(freeGiftQuantity, "freeGiftQuantity", freeGiftPro?.quantity, treeGiftPro?.quantity, "freeTreeQuantity", treeGiftPro?.quantity);
//       console.log(freeGiftPro, "freeGiftPro")
//       if (freeGiftPro) {
//         // [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + freeGiftQuantity,
//         if(String(freeGiftPro?.variant_id) ===  "44038167756870"){
//           updates = {
//               [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + (diff_quantity*2),
//             };
//         }else{
//           if (treeGiftPro) {
//           updates = {
//             [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) + diff_quantity,
//             [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + diff_quantity,
//           };
//         } else {
//           updates = {
//             [freeGiftPro?.key]: (freeGiftPro?.quantity || 0) + diff_quantity,
//           };
//         }
//         }
//       }

//       console.log(updates, "updates from one");
//       const response = await fetch("/cart/update.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ updates }),
//       });

//       const result = await response.json();
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
//       addToCart(productId, diff_quantity);
//       old_quantity = quantity;
//       await sectionRender();
//     } else {
//       let lastVariant = getLastVariant();
//       let lastProVariant = gc_cartData?.items?.find((cartItem) => {
//         return (
//           String(cartItem.variant_id) === String(lastVariant) &&
//           cartItem.properties._Gf_pdp === "giftItem"
//         );
//       });

//       let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => cartItem.properties._Gf_pdp);
//       let totalMylkyGiftQuantity = mylkyGiftPro.reduce(
//         (total, item) => total + (item.quantity || 0),
//         0
//       );
//       let updates = {};
//       let mylkyTreePro = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
//       let totalMylkyTreeQuantity = mylkyTreePro?.quantity;
//       let freeTreeQuantity = Math.abs(mylkyProQuantity - totalMylkyTreeQuantity)

//       if (totalMylkyGiftQuantity > mylkyProQuantity) {
//         // if (treeGiftPro) {
//         //   console.log("-------1");
//         //   updates = {
//         //     [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//         //   };
//         // }
//         if (lastProVariant) {
//             if(String(lastProVariant?.variant_id) ===  "44038167756870"){
//             updates = {
//                 [lastProVariant?.key]: (lastProVariant?.quantity || 0) - (diff_quantity * 2),
//               };
//                removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//             } else if (treeGiftPro) {
//             updates = {
//               [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//               [lastProVariant?.key]: (lastProVariant?.quantity || 0) - diff_quantity,
//             };
//             removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//           } else {
//             updates = {
//               [lastProVariant?.key]: (lastProVariant?.quantity || 0) - diff_quantity,
//             };
//             removeFromLocalStorage(lastProVariant?.variant_id,diff_quantity)
//           }
//         } else {
//           if (treeGiftPro) {
//             updates = {
//               [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//             };
//           }
//         }
//       } else  {
//         if (treeGiftPro) {
//           updates = {
//             [treeGiftPro?.key]: (treeGiftPro?.quantity || 0) - diff_quantity,
//           };
//         }
//       }
//       console.log(updates, "updates from two");

//       const response = await fetch("/cart/update.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ updates }),
//       });

//       const result = await response.json();
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
//       old_quantity = quantity;
//       await sectionRender();
//     }
//   }
// }

async function greenFridayUpdateToCart(quantity) {
  const items = gc_cartData?.items || [];
  const giftLines = items.filter(i => i?.properties?._Gf_pdp === "giftItem");
  const totalGift = giftLines.reduce((t, i) => t + (i.quantity || 0), 0);
  const mylkyQty = quantity || 0;
  const updates = {};

  if (!mylkyQty) {
    giftLines.forEach(i => { updates[i.key] = 0; });             // Mylky removed -> remove all gifts
  } else if (totalGift > mylkyQty) {                             // more gifts than Mylkys -> trim excess
    let excess = totalGift - mylkyQty;
    const lastVariant = String(getLastVariant());
    const ordered = [...giftLines].sort((a, b) =>
      (String(b.variant_id) === lastVariant) - (String(a.variant_id) === lastVariant));
    for (const line of ordered) {
      if (excess <= 0) break;
      const cut = Math.min(line.quantity, excess);
      updates[line.key] = line.quantity - cut;
      removeFromLocalStorage(line.variant_id, cut);
      excess -= cut;
    }
  }

  if (Object.keys(updates).length) {
    const response = await fetch("/cart/update.js?_gf_pdp", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ updates }),
    });
    const result = await response.json();
    if (!response.ok) { console.error("🚫 Error:", result); throw new Error(`Update failed: ${response.status}`); }
    if (!mylkyQty) removeLocalStorage();
    await sectionRender();
  }
  old_quantity = mylkyQty;
}

// async function greenFridayAddToCart(quantity) {
//   try {

//     const activeProduct = document.querySelector('.green-friday-product-wrapper .gf-pdp-active');
//     const productId = activeProduct?.getAttribute('data-productid');
//     const giftVariantId = "44038167756870";
//     const selectedProductId = parseInt(productId);
//     let diff_quantity = Math.abs(new_quantity - old_quantity);
//     // let giftProduct = gc_cartData?.items?.filter((cartItem) => {
//     //   return (
//     //     String(cartItem?.variant_id) === giftVariantId
//     //     || parseInt(cartItem?.variant_id) === selectedProductId
//     //   );
//     // })  || [];

//       let giftProduct = gc_cartData?.items?.filter((cartItem) => {
//       return (
//        cartItem.properties._Gf_pdp
//       );
//     }) || [];

//     let selectedProduct = gc_cartData?.items?.filter((cartItem) => {
//       return (
//         parseInt(cartItem?.variant_id) === selectedProductId && cartItem.properties._Gf_pdp === "giftItem"
//       );
//     }) || [];

//     if (giftProduct.length <= 0) {
//       const itemsToAdd = [
//         {
//           id: parseInt(productId),
//           quantity: 1,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         },
//         {
//           id: 44038167756870,
//           quantity: 1,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const response = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: itemsToAdd }),
//       });

//       const result = await response.json();
//       console.log(productId, "productId")
//       addToCart(productId);
//       old_quantity = quantity
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }

//        const treeItem = [
//         {
//             id: parseInt(productId),
//           quantity: 1,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const treeResponse = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: treeItem }),
//       });

//       const treeResult = await treeResponse.json();
//       await sectionRender()
//     } else if (selectedProduct?.length <= 0 && old_quantity < new_quantity) {

//       let diff_quantity = new_quantity - old_quantity
//       const itemsToAdd = [
//         {
//           id: parseInt(productId),
//           quantity: diff_quantity,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }, 
//         {
//           id: 44038167756870,
//           quantity: diff_quantity,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const response = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: itemsToAdd }),
//       });

//       const result = await response.json();
//       console.log(productId, "productId2")
//       console.log(diff_quantity, "diff_quantity")
//       addToCart(productId, diff_quantity);

//       old_quantity = quantity
//       if (!response.ok) {
//         console.error("🚫 Error:", result);
//         throw new Error(`Add to cart failed: ${response.status}`);
//       }
      
//       const treeItem = [
//          {
//           id: parseInt(productId),
//           quantity: diff_quantity,
//           properties: {
//             _Gf_pdp: "giftItem"
//           }
//         }
//       ];
//       const treeResponse = await fetch("/cart/add.js?_gf_pdp", {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//           Accept: "application/json",
//         },
//         body: JSON.stringify({ items: treeItem }),
//       });

//       const treeResult = await treeResponse.json();
      
//       await sectionRender()
//     } else {
//       await greenFridayUpdateToCart(quantity)
//     }
//   } catch (error) {
//     console.error("❌ Error adding to cart:", error);
//   }
// }

async function greenFridayAddToCart(quantity) {
  try {
    const productId = document.querySelector('.green-friday-product-wrapper .gf-pdp-active')?.getAttribute('data-productid');
    if (!productId) return;

    const giftLines = (gc_cartData?.items || []).filter(i => i?.properties?._Gf_pdp === "giftItem");
    const totalGift = giftLines.reduce((t, i) => t + (i.quantity || 0), 0);
    const missing = quantity - totalGift;          // one gift per Mylky

    if (missing > 0) {
      const response = await fetch("/cart/add.js?_gf_pdp", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: parseInt(productId), quantity: missing, properties: { _Gf_pdp: "giftItem" } }],
        }),
      });
      const result = await response.json();
      if (!response.ok) { console.error("🚫 Error:", result); throw new Error(`Add to cart failed: ${response.status}`); }
      addToCart(productId, missing);
      old_quantity = quantity;
      await sectionRender();
    } else {
      await greenFridayUpdateToCart(quantity);
    }
  } catch (error) {
    console.error("❌ Error adding to cart:", error);
  }
}

const gcCartApi = [
  { label: "add", url: "/cart/add.js" },
  { label: "add", url: "/cart/add" },
  { label: "change", url: "/cart/change.js" },
  { label: "change", url: "/cart/change" },
  { label: "update", url: "/cart/update.js" },
  { label: "update", url: "/cart/update" },
  { label: "clear", url: "/cart/clear.js" },
  { label: "clear", url: "/cart/clear" },
];

// document.addEventListener('cart:changed', async () => {
//   await gcGetCartData();
//   await greenFriday();
// });

document.addEventListener('cart:changed', () => { greenFriday(); });

window.fetch = async function (input, init = {}) {
  const url = typeof input === 'string'
    ? input
    : (input && typeof input.url === 'string' ? input.url : undefined);

  if (typeof url !== 'string') {
    const response = await gc_originalFetch(input, init);
    return response;
  }

  if (url.includes('_gf_pdp')) {
    return await gc_originalFetch(input, init);
  }

  const isCartMutation = gcCartApi.some(route => {
    const base = route.url.replace(".js", "");
    return (
      (url.includes(base) || url.includes(base + ".js"))
    );
  });

  const body = init.body || null;
  let line, quantity;
  let parsedBody;

  try {
    parsedBody = (typeof body === "string" && body.startsWith("{"))
      ? JSON.parse(body)
      : body;
  } catch {
    parsedBody = body;
  }

  if (parsedBody instanceof URLSearchParams || typeof parsedBody === "string") {
    const params = new URLSearchParams(
      typeof parsedBody === "string" ? parsedBody : parsedBody.toString()
    );
    line = parseInt(params.get("line"), 10);
    quantity = parseInt(params.get("quantity"), 10);
  } else if (typeof parsedBody === "object" && parsedBody !== null) {
    line = parseInt(parsedBody.line, 10);
    quantity = parseInt(parsedBody.quantity, 10);
  }

  const response = await gc_originalFetch(input, init);
  if (isCartMutation && response.ok) {
    setTimeout(async () => {
      document.dispatchEvent(new CustomEvent('cart:changed'));
    }, 200);
  }
  return response;
};

const originalXhrSend = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = async function (body) {
  const xhr = this;
  const url = xhr._url || xhr?.__sentry_xhr?.url || "";
  const method = xhr._method || xhr?.__sentry_xhr?.method || "GET";
  let parsedBody;
  try {
    parsedBody = typeof body === "string" && body.startsWith("{")
      ? JSON.parse(body)
      : body;
  } catch {
    parsedBody = body;
  }

  if (url.includes('_gf_pdp')) {
    return await gcXmlApiRequest(xhr, body);
  }

  let rawBody = "";
  if (typeof parsedBody === "string") {
    rawBody = parsedBody;
  } else if (parsedBody instanceof URLSearchParams) {
    rawBody = parsedBody.toString();
  } else if (parsedBody instanceof FormData) {
    rawBody = new URLSearchParams(parsedBody).toString();
  }
  const urlLineParams = new URLSearchParams(rawBody);
  const line = parseInt(urlLineParams.get("line"), 10);
  const quantity = parseInt(urlLineParams.get("quantity"), 10);
  const cartEndpoints = [
    '/cart/add.js', '/cart/change.js', '/cart/update.js',
    '/cart/add', '/cart/change', '/cart/update'
  ];
  const isCartMutation = gcCartApi.some(route => {
    const base = route.url.replace(".js", "");
    return (
      (url.includes(base) || url.includes(base + ".js"))
    );
  });

  let updatApi = [
    { label: "change", url: "/cart/change.js" },
    { label: "change", url: "/cart/change" },
    { label: "update", url: "/cart/update.js" },
    { label: "update", url: "/cart/update" },
  ];
  const isUpdateCartMutation = updatApi.some(route => {
    const base = route.url.replace(".js", "");
    return (
      (url.includes(base) || url.includes(base + ".js"))
    );
  });

  if (isUpdateCartMutation) {
    let cartDataItem = await gcGetCartData();
    cartDataItem?.items?.forEach((item, index) => {
    });

    let isGiftItem = cartDataItem?.items?.find((cartItem) => String(cartItem?.key) === String(parsedBody?.id));
    if ((line && cartDataItem?.items[line - 1]) || isGiftItem) {
      let cartItem = cartDataItem.items[line - 1] || isGiftItem;

      const params = new URLSearchParams(body);
      let payLoadData
      try {
        payLoadData = JSON.parse(body);
      } catch (e) {
        console.error("Failed to parse JSON body:", e);
      }
      parsedBody = {};

      let mylkyMainProData = gc_cartData?.items?.find((cartItem) => String(cartItem?.variant_id) === mylkyMainPro);
      let mylkyProQuantity = mylkyMainProData?.quantity;

      if (String(mylkyMainProData?.variant_id) === String(cartItem?.variant_id)) {
        old_quantity = cartItem?.quantity
      }

      if (cartItem.properties && (cartItem.properties._Gf_pdp || cartItem.properties._Gf_Tree_pdp)) {
        let mylkyMainProData = gc_cartData?.items?.find((cartItem) => String(cartItem?.variant_id) === mylkyMainPro);
        let mylkyProQuantity = mylkyMainProData?.quantity;
        let mylkyPlantProData = gc_cartData?.items?.find((cartItem) => cartItem.properties._Gf_Tree_pdp);
        let mylkyPlantQuantity = mylkyPlantProData?.quantity
        let mylkyGiftPro = gc_cartData?.items?.filter((cartItem) => (cartItem.properties._Gf_pdp ));
        let mylkyGiftQuantity = mylkyGiftPro.reduce(
          (total, item) => total + (item.quantity || 0),
          0
        );

        let mylkyGiftTreePro = gc_cartData?.items?.filter((cartItem) => (cartItem.properties._Gf_pdp && String(cartItem?.variant_id) !== "44038167756870") );
        let mylkyGiftTreeQuantity = mylkyGiftTreePro.reduce(
          (total, item) => total + (item.quantity || 0),
          0
        );

        let totalTreeCount = getVariantCount(44038167756870);
        let totalMylkyGiftQuantity = mylkyGiftTreeQuantity + totalTreeCount;
       
        if (mylkyGiftPro?.some(gift => gift.variant_id === cartItem?.variant_id)) {
              let totalMylkyTreeQuantity = totalMylkyGiftQuantity;
              if(String(cartItem?.variant_id) === "44038167756870"){
                if(parseInt(payLoadData.quantity) === 0){
                    let treeDiff = cartItem?.quantity
                    removeFromLocalStorage(cartItem?.variant_id, treeDiff)
                    return await gcXmlApiRequest(xhr, body);
                } else {
                      try {
                        if (typeof body === "string") {
                          if (body.includes("quantity=")) {
                            const params = new URLSearchParams(body);
                            if (params.has("quantity")) {
                              params.set("quantity", cartItem?.quantity); 
                              body = params.toString();
                            }
                          }
                          else if (body.trim().startsWith("{")) {
                            const temp = JSON.parse(body);
                            if (temp && temp.quantity !== undefined) {
                              temp.quantity = cartItem?.quantity; 
                              body = JSON.stringify(temp);
                            }
                          }
                        }
                      } catch (err) {
                        console.error("Failed to adjust quantity:", err);
                      }
                      return await gcXmlApiRequest(xhr, body);
                }
              }else{
                  if (totalMylkyGiftQuantity < mylkyProQuantity) {
                    let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
                    console.log(cartItem?.quantity, "cartItem?.quantity", payLoadData.quantity, "payLoadData.quantity")
                    if (cartItem?.quantity < payLoadData.quantity) {
                      addToCart(cartItem?.variant_id)
                    } else {
                      removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
                    }
                    return await gcXmlApiRequest(xhr, body);
                  } else {
                    if (cartItem?.quantity < payLoadData.quantity) {
                      try {
                        if (typeof body === "string") {
                          if (body.includes("quantity=")) {
                            const params = new URLSearchParams(body);
                            if (params.has("quantity")) {
                              params.set("quantity", cartItem?.quantity); 
                              body = params.toString();
                            }
                          }
                          else if (body.trim().startsWith("{")) {
                            const temp = JSON.parse(body);
                            if (temp && temp.quantity !== undefined) {
                              temp.quantity = cartItem?.quantity; 
                              body = JSON.stringify(temp);
                            }
                          }
                        }
                      } catch (err) {
                        console.error("Failed to adjust quantity:", err);
                      }
                      return await gcXmlApiRequest(xhr, body);
                    } else {
                      let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
                      removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
                      return await gcXmlApiRequest(xhr, body);
                    }
                  }
              }
            }
          }
          // if (cartItem?.quantity < payLoadData.quantity) {
          //   if (typeof parsedBody === "object") {
          //     parsedBody.quantity = cartItem?.quantity;
          //   } else if (parsedBody instanceof URLSearchParams) {
          //     parsedBody.set("quantity", cartItem?.quantity);
          //   }
          //   const newParams = new URLSearchParams(parsedBody).toString();
          //   return await gcXmlApiRequest(xhr, newParams);
          // } else {
          //   let diff_quantity = Math.abs(cartItem.quantity - payLoadData.quantity);
          //   removeFromLocalStorage(cartItem?.variant_id, diff_quantity)
          //   return await gcXmlApiRequest(xhr, body);
          // }
        }
  }
  await gcXmlApiRequest(xhr, body);
  if (isCartMutation) {
    setTimeout(() => {
      document.dispatchEvent(new CustomEvent('cart:changed'));
    }, 700);
  }
};

async function gcXmlApiRequest(xhr, params) {
  const intervals = 10;
  const maxTries = 50;
  let tries = 0;
  while (xhr.readyState !== XMLHttpRequest.OPENED && tries < maxTries) {
    await new Promise(res => setTimeout(res, intervals));
    tries++;
  }
  if (xhr.readyState === XMLHttpRequest.OPENED) {
    try {
      gc_originalSend.call(xhr, params);
    } catch (err) {
      console.error("Failed during send:-", err);
    }
  } else {
    console.warn("xhr not open after waiting, skipping send");
  }
}

// green friday end--------------------------------------------------------------------------------------------------------------------------





// var mylkyMainPro = "42571798609990";
// var mylkyGiftPro = "44449800618054";
var mylkyGiftPro = "42571798708294";
// let gc_cartData;
let isRemovingGift = false;
// const originalXhrSend = XMLHttpRequest.prototype.send;
let mainProQuantity;

async function gcGetCartData() {
  const res = await fetch("/cart.json", {
    headers: { "x-bypass-intercept": "1" },
  });
  gc_cartData = await res.json();
  return gc_cartData;
}

// const gcCartApi = [
//   { label: "add", url: "/cart/add.js" },
//   { label: "add", url: "/cart/add" },
//   { label: "change", url: "/cart/change.js" },
//   { label: "change", url: "/cart/change" },
//   { label: "update", url: "/cart/update.js" },
//   { label: "update", url: "/cart/update" },
//   { label: "clear", url: "/cart/clear.js" },
//   { label: "clear", url: "/cart/clear" },
// ];

const removeMylkyGift = async () => {
  if (!gc_cartData?.items?.length) return;
  const updates = {};
  const giftProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyGiftPro &&
      item?.properties?._Gf_pdp
  );
  if (!giftProduct.length) return;

  giftProduct.forEach((cartItem) => {
    updates[cartItem?.key] = 0;
  });

  const response = await fetch("/cart/update.js?_gf_pdp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ updates }),
  });

  const result = await response.json();

  if (!response.ok) {
    console.error("🚫 Error:", result);
    throw new Error(`Cart update failed: ${response.status}`);
  }
};

const updateMylkyGift = async () => {
  if (!gc_cartData?.items?.length) return;
  const updates = {};
  const giftProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyGiftPro &&
      item?.properties?._Gf_pdp
  );
  if (!giftProduct.length) return;

  giftProduct.forEach((cartItem) => {
    updates[cartItem?.key] = mainProQuantity;
  });

  const response = await fetch("/cart/update.js?_gf_pdp", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ updates }),
  });

  const result = await response.json();
  await gcGetCartData();
  if (!response.ok) {
    console.error("🚫 Error:", result);
    throw new Error(`Cart update failed: ${response.status}`);
  }
};

document.addEventListener("cart:changed", async () => {
      if (isRemovingGift) return;
      isRemovingGift = true;
      await gcGetCartData();
      if(!mainProQuantity || mainProQuantity === 0){
          await removeMylkyGift();
      }else{
         await updateMylkyGift();
  }
 
  isRemovingGift = false;
});

function getVariantId(value) {
  return typeof value === "string" ? value.split(":")[0] : value;
}

XMLHttpRequest.prototype.send = async function (body) {
  const xhr = this;
  const url = xhr._url || xhr?.__sentry_xhr?.url || "";
  const method = xhr._method || xhr?.__sentry_xhr?.method || "GET";

  let parsedBody;
  try {
    parsedBody =
      typeof body === "string" && body.startsWith("{")
        ? JSON.parse(body)
        : body;
  } catch {
    parsedBody = body;
  }

  if (url.includes("_gf_pdp")) {
    return originalXhrSend.call(xhr, body);
  }
  const quantity = parsedBody?.quantity;
  let variantId = parsedBody?.id;
  variantId = getVariantId(variantId);
  const updatApi = [
    { label: "change", url: "/cart/change.js" },
    { label: "change", url: "/cart/change" },
    { label: "update", url: "/cart/update.js" },
    { label: "update", url: "/cart/update" },
  ];

  const isUpdateCartMutation = updatApi.some((route) => {
    const base = route.url.replace(".js", "");
    return url.includes(base) || url.includes(base + ".js");
  });

  if (isUpdateCartMutation && variantId) {
    await gcGetCartData();
     const giftProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyGiftPro &&
      item?.properties?._Gf_pdp
  );
    const mainProduct = gc_cartData?.items?.filter(
    (item) =>
      String(item?.variant_id) === mylkyMainPro 
  );

        if (
          String(variantId) === String(mylkyGiftPro) &&
         (quantity > giftProduct?.[0]?.quantity)
        ) {
         let parsedBody = {};
         if (typeof parsedBody === "object") {
              parsedBody.quantity = giftProduct?.[0]?.quantity;
            } else if (parsedBody instanceof URLSearchParams) {
              parsedBody.set("quantity", giftProduct?.[0]?.quantity);
            }
            const newParams = new URLSearchParams(parsedBody).toString();
              return originalXhrSend.call(xhr, newParams);
        }  else if (
          String(variantId) === String(mylkyMainPro) &&
          quantity === 0
        ) {
          mainProQuantity = 0
            document.dispatchEvent(new CustomEvent("cart:changed"));
        } else if(quantity < mainProduct?.[0]?.quantity){
            mainProQuantity=quantity;
            document.dispatchEvent(new CustomEvent("cart:changed"));
        }
  }
  return originalXhrSend.call(xhr, body);
};

function gcXmlApiRequest(xhr, params) {
  try {
    originalXhrSend.call(xhr, params);
  } catch (err) {
    console.error("Failed during send:", err);
  }
}

document.querySelectorAll('.mobile-cart-trigger').forEach((btn) => {
  btn.addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('#cart-icon-bubble').click();
  });
});

// Green Friday: gift qty must never exceed main Mylky qty
// (also catches gifts added via /cart/add?id=... links, which carry no line properties)
(function () {
  const MAIN_MYLKY_VARIANT_ID = "42571798609990";

  // Verify this list covers every gift variant (product_1..product_7 in the gf-pdp block)
  const GIFT_VARIANT_IDS = [
    "44038160810054",
    "44038165692486",
    "50576160620614",
    "50576169861190",
    "50576166453318",
    "50576166813766",
    "50576168091718",
  ];
  const GIFT_HANDLE_MARKER = "green-friday-gift"; // fallback match on product handle

  let running = false;

  const isGift = (item) =>
    String(item.variant_id) !== MAIN_MYLKY_VARIANT_ID &&
    (GIFT_VARIANT_IDS.includes(String(item.variant_id)) ||
      item?.properties?._Gf_pdp === "giftItem" ||
      String(item.handle || "").includes(GIFT_HANDLE_MARKER));

  async function enforceGiftLimit() {
    if (running) return;
    running = true;

    try {
      const res = await fetch("/cart.js?t=" + Date.now(), { cache: "no-store" });
      if (!res.ok) throw new Error("Unable to retrieve cart");
      const cart = await res.json();

      const mylkyQty = cart.items
        .filter((i) => String(i.variant_id) === MAIN_MYLKY_VARIANT_ID)
        .reduce((t, i) => t + (i.quantity || 0), 0);

      const gifts = cart.items.filter(isGift);
      const totalGift = gifts.reduce((t, i) => t + (i.quantity || 0), 0);
      let excess = totalGift - mylkyQty;

      if (excess <= 0) return;

      // Trim lines WITHOUT the _Gf_pdp property first (URL-added), legit ones last
      const ordered = [...gifts].sort(
        (a, b) => Number(!!a.properties?._Gf_pdp) - Number(!!b.properties?._Gf_pdp)
      );

      const updates = {};
      for (const line of ordered) {
        if (excess <= 0) break;
        const cut = Math.min(line.quantity, excess);
        updates[line.key] = line.quantity - cut;
        if (typeof removeFromLocalStorage === "function") {
          removeFromLocalStorage(line.variant_id, cut);
        }
        excess -= cut;
      }

      // "_gf_pdp" in the URL makes the fetch/XHR interceptors skip this call (no loop)
      const updateRes = await fetch("/cart/update.js?_gf_pdp", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ updates })
      });
      if (!updateRes.ok) throw new Error("Unable to trim gift products");

      if (mylkyQty === 0 && typeof removeLocalStorage === "function") {
        removeLocalStorage();
      }

      if (document.querySelector("cart-drawer") && typeof sectionRender === "function") {
        await sectionRender();
      } else if (window.location.pathname.replace(/\/$/, "").endsWith("/cart")) {
        window.location.reload(); // cart page (no drawer) -> refresh to show corrected cart
      }
    } catch (error) {
      console.error("Green Friday gift enforcement failed:", error);
    } finally {
      running = false;
    }
  }

  // 1) On every page load (covers the redirect to /cart after /cart/add?id=...)
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", enforceGiftLimit, { once: true });
  } else {
    enforceGiftLimit();
  }

  // 2) After any cart change, once the existing gift add/update logic has settled
  document.addEventListener("cart:changed", () => setTimeout(enforceGiftLimit, 800));
})();

// GF PDP: when the page opens, sync gifts with the Mylky already in the cart
// (reuses the existing cart:changed -> greenFriday() flow)
(function () {
  function syncGiftsOnGfPdp() {
    // Only on the GF template: the gift selector exists and a gift is preselected
    if (!document.querySelector(".green-friday-product-wrapper .gf-pdp-active")) return;
    document.dispatchEvent(new CustomEvent("cart:changed"));
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", syncGiftsOnGfPdp, { once: true });
  } else {
    syncGiftsOnGfPdp();
  }
})();

// Cart Recommedation
// let cachedRecommendations = null;
// let cachedProductId = null;

// async function loadCartRecommendations() {

//   const container = document.querySelector(".cart-drawer-recommendations");
//   const list = document.querySelector(".cart-recommendations__list");

//   if (!list || !container) return;

//   const cart = await fetch("/cart.js").then(r => r.json());

//   if (!cart.items.length) {
//     container.style.display = "none";
//     return;
//   }

//   const cartVariants = cart.items.map(i => String(i.variant_id));
//   const latestItem = cart.items[cart.items.length - 1];
//   const firstITem = cart.items[0];
//   const productId = latestItem.product_id;

//   let newWrapper = null;

//   /* FETCH NEW DATA ONLY IF PRODUCT CHANGED */
//   if (!cachedRecommendations || cachedProductId !== productId) {
//     const response = await fetch(`/recommendations/products?section_id=cart-drawer-recommendations&product_id=${productId}&intent=related`);
//     const html = await response.text();

//     const parser = new DOMParser();
//     const doc = parser.parseFromString(html, "text/html");

//     cachedRecommendations = doc.querySelector(".cart-recommendations__items");
//     cachedProductId = productId;
//   }

//   if (!cachedRecommendations) return;

//   /* PREPARE NEW WRAPPER OFF-DOM */
//   newWrapper = cachedRecommendations.cloneNode(true);
//   newWrapper.querySelectorAll(".cart-recommendation-item").forEach(item => {
//     const variantId = item.dataset.variant;
//     if (cartVariants.includes(String(variantId))) {
//       item.remove();
//     }
//   });

//   const remainingItems = newWrapper.querySelectorAll(".cart-recommendation-item");

//   /* HIDE SECTION IF NO RECOMMENDATIONS */
//   if (!remainingItems.length) {
//     const existingWrapper = list.querySelector(".cart-recommendations__items");
//     if (existingWrapper) {
//       existingWrapper.remove();
//     }
//     container.style.display = "none";
//     return;
//   }

//   container.style.display = "";

//   /* ONLY NOW REPLACE OLD DATA */
//   const existingWrapper = list.querySelector(".cart-recommendations__items");
//   if (existingWrapper) {
//     existingWrapper.replaceWith(newWrapper);
//   } else {
//     list.appendChild(newWrapper);
//   }
// }

// /* OBSERVE CART DRAWER CHANGES */
// function observeCartDrawer() {
//   const target = document.querySelector("#CartDrawer");

//   if (!target) return;
//   if (window.cartDrawerObserver) {
//     window.cartDrawerObserver.disconnect();
//   }

//   window.cartDrawerObserver = new MutationObserver(async () => {
//     const list = document.querySelector(".cart-recommendations__list");
//     if (list && list.innerHTML.trim() === "") {
//       await loadCartRecommendations();
//     }
//   });

//   window.cartDrawerObserver.observe(target, {
//     childList: true,
//     subtree: true
//   });
// }

// /* PAGE LOAD */
// document.addEventListener("DOMContentLoaded", async () => {
//   await loadCartRecommendations();
//   await observeCartDrawer();
// });

// document.addEventListener("cart:changed", loadCartRecommendations);
// document.addEventListener("cart:refresh", loadCartRecommendations);

// $(document).on("click", "#cart-icon-bubble", loadCartRecommendations);

/* ADD RECOMMENDATION PRODUCT */
$(document).on("click", ".cart-recommendation-add", async function (e) {
  e.preventDefault();

  const button = $(this);
  const variantId = button.data("variant-id");

  /* SHOW SPINNER */
  button.addClass("loading");
  button.prop("disabled", true);

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ["cart-drawer","cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    });

    const data = await response.json();

    if (data.sections["cart-drawer"]) {
      const parser = new DOMParser();
      const html = parser.parseFromString(data.sections["cart-drawer"], "text/html");
      const newDrawer = html.querySelector("#CartDrawer");

      if (newDrawer) {
        document.querySelector("#CartDrawer").innerHTML = newDrawer.innerHTML;
        observeCartDrawer();
      }
    }

    if (data.sections["cart-icon-bubble"]) {
      document.querySelector("#cart-icon-bubble").innerHTML = data.sections["cart-icon-bubble"];
    }

    document.dispatchEvent(new CustomEvent("cart:changed"));
  } catch (error) {
    console.error("Add to cart failed:", error);
  } finally {
    /* RESTORE BUTTON */
    button.removeClass("loading");
    button.prop("disabled", false);
  }
});


// document.addEventListener("DOMContentLoaded", function () {
//   const announcement = document.querySelector(".announcement-bar-section");
//   const header = document.querySelector(".section-header");

//   if (!announcement || !header) return;

//   let lastScroll = window.pageYOffset;

//   const updateHeaderTop = (scrollingUp) => {

//     const isSticky = header.classList.contains("shopify-section-header-sticky");
//     const isHidden = header.classList.contains("shopify-section-header-hidden");

//     // 1️⃣ If hidden → always apply hidden top
//     if (isHidden) {
//       header.style.top = "calc(-1 * var(--header-height))";
//       return;
//     }

//     // 2️⃣ If sticky + scrolling UP → apply announcement offset
//     if (isSticky && scrollingUp) {
//       header.style.top = announcement.offsetHeight + "px";
//       return;
//     }

//     // 3️⃣ Default
//     header.style.top = "0px";
//   };

//   window.addEventListener("scroll", function () {
//     const currentScroll = window.pageYOffset;
//     const scrollingUp = currentScroll < lastScroll;

//     updateHeaderTop(scrollingUp);

//     lastScroll = currentScroll;
//   });

//   window.addEventListener("resize", function () {
//     if (header.classList.contains("shopify-section-header-sticky")) {
//       header.style.top = announcement.offsetHeight + "px";
//     }
//   });

//   updateHeaderTop(false);
// });

document.addEventListener('DOMContentLoaded', function () {
  const menu = document.querySelector('header-drawer');

  if (!menu) return;

  function updateTidio() {
    const isMenuOpen = menu.querySelector('details')?.hasAttribute('open');
    const isCartOpen = document.querySelector('cart-drawer')?.classList.contains('active');
    const tidio = document.querySelector('#tidio-chat');

    document.body.classList.toggle('mobile-login', isMenuOpen);

    if (!tidio) return;

    if (isMenuOpen || isCartOpen) {
      tidio.style.setProperty('z-index', '2', 'important');
    } else {
      tidio.style.setProperty('z-index', '999999999', 'important');
    }
  }

  new MutationObserver(updateTidio).observe(menu, {
    subtree: true,
    attributes: true,
    attributeFilter: ['open']
  });

  new MutationObserver(updateTidio).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class']
  });
});

// (function () {
//   function initMylkyTidio() {
//     // Only run on the support template
//     const supportPage = document.querySelector('main.template-support');

//     if (!supportPage) return;

//     const assistantButton = supportPage.querySelector(
//       '[data-mylky-assistant-trigger]'
//     );

//     if (!assistantButton) return;

//     function setupTidio() {
//       if (!window.tidioChatApi) return;

//       // Initial state:
//       // Completely hide Tidio on the support page
//       window.tidioChatApi.hide();

//       // When customer clicks the Tidio close button:
//       // hide the entire Tidio widget again
//       window.tidioChatApi.on('beforeClose', function () {
//         window.tidioChatApi.hide();
//       });
//     }

//     // Ask Mylky assistant button
//     assistantButton.addEventListener('click', function (event) {
//       event.preventDefault();

//       if (!window.tidioChatApi) return;

//       window.tidioChatApi.show();
//       window.tidioChatApi.open();
//     });

//     // Tidio already available
//     if (window.tidioChatApi) {
//       window.tidioChatApi.on('ready', setupTidio);
//     } else {
//       // Tidio loads asynchronously
//       document.addEventListener('tidioChat-ready', setupTidio);
//     }
//   }

//   if (document.readyState === 'loading') {
//     document.addEventListener('DOMContentLoaded', initMylkyTidio);
//   } else {
//     initMylkyTidio();
//   }
// })();

(function () {
  function initMylkyTidio() {
    const supportPage = document.querySelector('main.template-support');

    if (!supportPage) return;

    const assistantButton = supportPage.querySelector(
      '[data-mylky-assistant-trigger]'
    );

    if (!assistantButton) return;

    function getTidioChat() {
      return document.querySelector('#tidio-chat');
    }

    function setTidioDisplay(display) {
      const tidioChat = getTidioChat();

      if (tidioChat) {
        tidioChat.style.setProperty('display', display, 'important');
      }
    }

    function hideTidio() {
      if (!window.tidioChatApi) return;

      window.tidioChatApi.hide();
      setTidioDisplay('none');
    }

    function showTidio() {
      if (!window.tidioChatApi) return;

      setTidioDisplay('block');
      window.tidioChatApi.show();
      window.tidioChatApi.open();
    }

    function setupTidio() {
      if (!window.tidioChatApi) return;

      // Initially hide Tidio
      hideTidio();

      // Hide only when the user actually closes Tidio
      window.tidioChatApi.on('beforeClose', function () {
        setTidioDisplay('none');
      });
    }

    assistantButton.addEventListener('click', function (event) {
      event.preventDefault();

      if (!window.tidioChatApi) return;

      showTidio();
    });

    if (window.tidioChatApi) {
      window.tidioChatApi.on('ready', setupTidio);
    } else {
      document.addEventListener('tidioChat-ready', setupTidio);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMylkyTidio);
  } else {
    initMylkyTidio();
  }
})();